module.exports = __webpack_public_path__ + "static/img/property-type.2d7184d1.png";